<template>
  <div class="c-sidenav__menu-item">
    <router-link class="c-sidenav-menu__wrapper" :to="{ name: 'notificationsOverview' }" title="Notifications" @click.native="closeMenu">
      <div class="c-sidenav-menu__icon-wrapper">
        <base-loading class="c-sidenav-menu__icon-loading" :is-active="isLoading" :can-show-label="false" is-small is-inversed></base-loading>
        <transition name="fade-transition" mode="out-in">
          <font-awesome-icon v-if="isLoading === false" class="c-sidenav-menu__icon" :icon="['fas', 'bell']"/>
        </transition>
        <div v-if="!isLoading && unreadNotificationsCount > 0" class="c-sidenav-menu__new-notification"></div>
      </div>
      <div class="c-sidenav-menu__text">
        <div class="c-sidenav-menu__text-title">
          {{ $t('label.notifications')}}
          <template v-if="unreadNotificationsCount > 0">({{ unreadNotificationsCount }})</template>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

import { menu } from '@/mixins/helpers'

export default {
  name: 'SideNavNotification',

  mixins: [ menu ],

  computed: {
    isLoading () {
      return this.$store.state.notifications.isFetching
    },

    unreadNotificationsCount () {
      return this.$store.state.notifications.totalUnreadCount
    }
  }
}
</script>
